var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgPlusCircleOutline = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0999 9.60039C13.0999 9.26902 12.8313 9.00039 12.4999 9.00039C12.1685 9.00039 11.8999 9.26902 11.8999 9.60039L11.8999 11.4004H10.0999C9.76853 11.4004 9.4999 11.669 9.4999 12.0004C9.4999 12.3318 9.76853 12.6004 10.0999 12.6004H11.8999V14.4004C11.8999 14.7318 12.1685 15.0004 12.4999 15.0004C12.8313 15.0004 13.0999 14.7318 13.0999 14.4004V12.6004H14.8999C15.2313 12.6004 15.4999 12.3318 15.4999 12.0004C15.4999 11.669 15.2313 11.4004 14.8999 11.4004H13.0999V9.60039Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4999 3.40039C7.75025 3.40039 3.8999 7.25074 3.8999 12.0004C3.8999 16.75 7.75025 20.6004 12.4999 20.6004C17.2496 20.6004 21.0999 16.75 21.0999 12.0004C21.0999 7.25074 17.2496 3.40039 12.4999 3.40039ZM5.0999 12.0004C5.0999 7.91348 8.413 4.60039 12.4999 4.60039C16.5868 4.60039 19.8999 7.91348 19.8999 12.0004C19.8999 16.0873 16.5868 19.4004 12.4999 19.4004C8.413 19.4004 5.0999 16.0873 5.0999 12.0004Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPlusCircleOutline, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/PlusCircleOutline.469c2920.svg";
export { ForwardRef as ReactComponent };